import type { ExtractGetRoutes, RouteSegment } from '@openclassrooms/sdk';

import type { ApiRoutes, GetRequestBuilder, RequestOption } from '../types';

import executeRequest from './executeRequest';

export default function get<
  Path extends ExtractGetRoutes<ApiRoutes> & RouteSegment,
  RequestBuilder extends GetRequestBuilder<Path> = GetRequestBuilder<Path>
>(
  path: Path,
  options?: RequestOption<RequestBuilder> & {
    pagination?: {
      rangeStart?: number;
      rangeEnd?: number;
    };
  }
) {
  return executeRequest('GET', path, options as any);
}
